import { TFunction } from 'react-i18next';
import { OnlineLayoutObject } from 'common/types';
import { isValidUrl } from '../atoms/validation';
import {
	FeaturedImageButton,
	HeaderLogoPlacement,
	OnlineLayoutSettings,
	SliderValue,
} from './types';

export const getDefaultOnlineLayout = () => ({
	defaultLayout: 'products' as 'products',
	header: {
		logo: {
			placement: 'left' as HeaderLogoPlacement,
			width: 70 as SliderValue,
		},
	},
	productGridColumns: {
		desktop: 3 as SliderValue,
	},
	featuredImage: {
		src: null,
		alignment: 'center' as 'center',
		button: null,
	},
	footer: {
		about: {
			hidden: false,
		},
		menu: {
			hidden: false,
			toggleMenu: false,
		},
		links: {
			hidden: false,
		},
	},
	about: {
		hidden: false,
	},
});

export const getOnlineLayoutSettings = (
	layout: OnlineLayoutObject | undefined,
	locationId: string | undefined,
): OnlineLayoutSettings => {
	const defaultLayout: OnlineLayoutSettings = getDefaultOnlineLayout();

	if (!locationId) return defaultLayout;

	const shopsActiveLayout = layout?.locations?.[locationId];
	const shopsDefaultLayout = layout?.default;

	return {
		...defaultLayout,
		...(shopsActiveLayout ?? shopsDefaultLayout),
	};
};

export const isValidButton = (
	button: FeaturedImageButton | null,
	t: TFunction,
): { valid: boolean; message?: string } => {
	if (!button?.label?.def && !button?.src) return { valid: true };
	const hasBothFields = !!button?.label?.def && !!button.src;
	const isValidLink = isValidUrl(button?.src ?? '');

	if (hasBothFields && isValidLink) {
		return { valid: true };
	} else if (!hasBothFields) {
		return {
			valid: false,
			message: t('common:validation.mustContainBothFields', 'Must contain both fields'),
		};
	} else if (!isValidLink) {
		return {
			valid: false,
			message: t('common:validation.mustContainURLProtocol', 'The url must begin with "https://"'),
		};
	}
	return { valid: true };
};
